import {component} from '../form/Constant'

export const pathwayKeys = {
    pathway: 'pathway',
    clientId: 'clientId',
    name: 'name',
    description: 'description',
    icon: 'icon',
    symptoms: 'symptoms',
}

export const pathwayList = [
    {
        key: pathwayKeys.pathway,
        description: 'Fill in the following information to create a path way',
        children: [
            {
                key: pathwayKeys.name,
                component: component.inputText,
                required: true,
                placeholder: "Input pathway's name - Field is required",
                defaultValue: '',
            },
            {
                key: pathwayKeys.description,
                component: component.inputText,
                placeholder: 'A short description',
                defaultValue: '',
            },
            {
                key: pathwayKeys.symptoms,
                component: component.chip,
                placeholder: `Press 'Enter' to complete your symptoms input`,
                defaultValue: '',
                required: true,
            },
            {
                key: pathwayKeys.icon,
                component: component.fileUpload,
                placeholder: "Input pathway's icon - Field is required",
                required: true,
                defaultValue: '',
            },
        ],
    },
]

export const styledPathwayList = [
    {
        key: pathwayKeys.name,
        component: component.inputText,
        required: true,
        placeholder: "Input pathway's name - Field is required",
        defaultValue: '',
    },
    {
        key: pathwayKeys.description,
        component: component.inputText,
        placeholder: 'A short description',
        defaultValue: '',
    },
    {
        key: pathwayKeys.icon,
        component: component.fileUpload,
        placeholder: "Input pathway's icon - Field is required",
        required: true,
        defaultValue: '',
    },
    {
        key: pathwayKeys.symptoms,
        component: component.pathway,
        placeholder: `Press 'Enter' to complete your symptoms input`,
        defaultValue: '',
        required: true,
    },
]

export const symptomSuggestionList = [
    {
        label: 'Respiratory Symptoms',
        value: [
            'Cough',
            'Shortness of breath',
            'Nasal congestion',
            'Sore throat',
            'Wheezing',
            'Chest tightness',
            'Phlegm production',
            'Difficulty breathing',
            'Hoarseness',
        ],
    },
    {
        label: 'Digestive Symptoms',
        value: [
            'Abdominal pain',
            'Diarrhea',
            'Constipation',
            'Heartburn',
            'Nausea',
            'Vomiting',
        ],
    },
    {
        label: 'Neurological Symptoms',
        value: [
            'Headache',
            'Dizziness',
            'Imbalance',
            'Numbness',
            'Cognitive disorders',
            'Seizures',
        ],
    },
    {
        label: 'Cardiovascular Symptoms',
        value: [
            'Chest pain',
            'Palpitations',
            'Shortness of breath on exertion',
            'Swelling of the legs',
            'Irregular heartbeat',
        ],
    },
    {
        label: 'Dermatological Symptoms',
        value: [
            'Itchy skin',
            'Rashes',
            'Bruising',
            'Dry skin',
            'Acne',
            'Abnormal hair growth',
        ],
    },
    {
        label: 'Systemic Symptoms',
        value: [
            'Fatigue',
            'Weight loss without cause',
            'Excessive sweating',
            'Unexplained weight gain',
            'Hair loss',
        ],
    },
    {
        label: 'Urinary Symptoms',
        value: [
            'Painful urination',
            'Frequent urination',
            'Dark or cloudy urine',
            'Blood in urine',
        ],
    },
    {
        label: 'Musculoskeletal Symptoms',
        value: [
            'Joint pain',
            'Muscle pain',
            'Stiff joints',
            'Swelling in joints',
        ],
    },
    {
        label: 'Endocrine Symptoms',
        value: [
            'Unexplained weight changes',
            'Excessive sweating',
            'Increased or decreased appetite',
            'Irregular menstrual cycles',
            'Hair thinning',
        ],
    },
    {
        label: 'Psychological Symptoms',
        value: [
            'Anxiety',
            'Depression',
            'Stress',
            'Insomnia',
            'Mood swings',
            'Feelings of emptiness',
        ],
    },
    {
        label: 'Eye Symptoms',
        value: [
            'Blurry vision',
            'Night blindness',
            'Red eyes',
            'Dry eyes',
            'Double vision',
            'Sudden loss of vision',
        ],
    },
    {
        label: 'Ear, Nose, and Throat Symptoms',
        value: [
            'Ear pain',
            'Hearing loss',
            'Tinnitus',
            'Nasal congestion',
            'Sore throat',
            'Loss of smell',
        ],
    },
    {
        label: 'Blood Pressure Symptoms',
        value: [
            'High blood pressure',
            'Low blood pressure',
            'Dizziness upon standing',
            'Headaches',
        ],
    },
    {
        label: 'Infection Symptoms',
        value: [
            'High fever',
            'Chills',
            'Muscle aches',
            'Swollen lymph nodes',
            'Fatigue',
            'Sore throat',
        ],
    },
    {
        label: 'Cancer Symptoms',
        value: [
            'Unexplained weight loss',
            'Persistent pain',
            'Cough',
            'Difficulty swallowing',
            'Changes in bowel or urinary habits',
            'Unhealing sores',
        ],
    },
]
